<script>
import Input from 'element-ui/lib/input';

export default Input;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/input.css';
@import '../../stylesheets/utils/utils';
// Adding RTL support to element's input

.el-input {
  &__suffix {
    @include rtl() {
      left: 5px;
      right: auto;
    }

    @include ltr-direct() {
      right: 5px;
      left: auto;
    }
  }

  &__prefix {
    @include rtl() {
      right: 5px;
      left: auto;
    }

    @include ltr-direct() {
      left: 5px;
      right: auto;
    }
  }

  &.text-latin {
    .el-input__suffix {
      right: 5px;
      left: auto;
    }
  }

  &__count {
    color: #aaa !important;
  }
}

.el-input--suffix .el-input__inner {
  @include rtl() {
    padding-left: 30px;
    padding-right: 15px;
  }
}

.el-input--prefix .el-input__inner {
  @include rtl() {
    padding-right: 30px;
    padding-left: 15px;
  }
}

.el-input-group {
  // &__prepend {
  //  width: auto;
  // }
  @include rtl() {
    .el-input__inner:first-child {
      border-radius: 0 4px 4px 0;
    }

    .el-input__inner:last-child {
      border-radius: 4px 0 0 4px;
    }

    &__append {
      border-right: 0;
      border-left: 1px solid #c0ccda;
      border-radius: 4px 0 0 4px;
      color: inherit;
    }

    &__prepend {
      border-right: 1px solid #c0ccda;
      border-left: 0;
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
